/**
 * Contact information constants for edgefi
 */

export const PHONE_NUMBERS = {
  SALES: {
    number: '360-625-9277',
    formatted: '(360) 625-9277',
    label: 'Sales Inquiries',
    description: 'Speak with a Security Expert Today',
    href: 'tel:+13606259277'
  },
  SUPPORT: {
    number: '360-450-0033', 
    formatted: '(360) 450-0033',
    label: 'Help & Support',
    description: 'Get Answers in Minutes, Not Days',
    href: 'tel:+13604500033'
  }
} as const;

export const BUSINESS_HOURS = {
  timezone: 'Pacific Time',
  hours: 'Mon-Fri: 8:00 AM - 6:00 PM PT',
  emergency: '24/7 Emergency Support Available'
} as const;